export default __webpack_public_path__ + "static/media/IBMPlexSans-Regular.30299e22.woff";